import Viewer from './components/Viewer';

function App() {
  return (
    <Viewer/>
  );
}

export default App;
